/** Shared breakpoint where the product shell switches between rail and drawer navigation. */
export const LAYOUT_MOBILE_DESKTOP_RESPONSIVE_BREAKPOINT = "md";
